import Vue from "vue";
import Router from "vue-router";

import Layout from "@/layouts/Layout"

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: "home",
            component: Layout,
            children: [
                {
                    name: "home",
                    path: "/home",
                    component: () => import('../views/Home')
                },
                {
                    name: "course",
                    path: "/course",
                    component: () => import('../views/Course')
                },
                {
                    name: "plantform",
                    path: "/plantform",
                    component: () => import('../views/Plantform')
                },
                {
                    name: "matchNews",
                    path: "/matchNews",
                    component: () => import('../views/MatchNews')
                },
                {
                    name: "growup",
                    path: "/growup",
                    component: () => import('../views/Growup')
                },
                {
                    name: "school",
                    path: "/school",
                    component: () => import('../views/School')
                },
            ]
        },

    ]
})
